import * as React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import Countdown from "react-countdown";
import moment from "moment";
import { ContentUkm, GetTimeAltResponse, GetUkmResponse } from "../../constants/types";

type CountdownProps = { expiredTime: number };

const CountdownDisplay: React.FC<CountdownProps> = React.memo(
    ({ expiredTime }) => (
        <Countdown
            date={Date.now() + expiredTime - 4000}
            renderer={({ completed, formatted }) => {
                if (completed) return <span>00:00:00</span>;
                return (
                    <Typography
                        display="inline"
                        sx={{
                            fontWeight: "bold",
                            color: "rgba(69, 167, 121, 1)",
                        }}
                    >
                        {formatted.days} hari, {formatted.hours} jam
                    </Typography>
                );
            }}
        />
    ),
);

type Props = {
    ukmData: ContentUkm | undefined;
    time: GetTimeAltResponse | undefined;
    ukmIsDueExpired: GetUkmResponse["data"] | undefined;
    expiredTime: number;
    onOpenModalTrial: () => void;
    onOpenModalAlertPro: () => void;
};

export default function SubscriptionBanner({
    ukmData,
    time,
    ukmIsDueExpired,
    expiredTime,
    onOpenModalTrial,
    onOpenModalAlertPro,
}: Props) {
    if (!ukmData) return null;

    return (
        <>
            {ukmIsDueExpired &&
                ukmIsDueExpired.totalElements > 0 &&
                ukmIsDueExpired.content
                    .filter((item) => item.id === ukmData.id)
                    .map((item) => (
                        <Box
                            key={item.id}
                            display="flex"
                            justifyContent="center"
                            padding={1}
                            sx={{
                                bgcolor: "rgba(229, 40, 40, 0.1)",
                                border: "1px solid rgba(229, 40, 40, 1)",
                            }}
                        >
                            {moment(time?.dateTime).isAfter(
                                item.pembayaranBerikutnya,
                            ) ? (
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Typography
                                        component="div"
                                        color="#6D6D6D"
                                        variant="body2"
                                    >
                                        Langganan <b>{item.namaToko}</b>{" "}
                                        sudah lewat jatuh tempo{" "}
                                        <Box
                                            display="inline"
                                            fontWeight="bold"
                                            color="#E52828"
                                        >
                                            {item.pembayaranBerikutnya === null
                                                ? ""
                                                : new Date(
                                                      item.pembayaranBerikutnya,
                                                  ).toLocaleString("id", {
                                                      day: "numeric",
                                                      month: "long",
                                                      year: "numeric",
                                                  })}
                                        </Box>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="buttonred"
                                        disableElevation
                                        onClick={onOpenModalAlertPro}
                                        sx={{ minWidth: 130, maxWidth: 130 }}
                                    >
                                        Upgrade ke Standar
                                    </Button>
                                </Stack>
                            ) : (
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <Typography color="rgba(229, 40, 40, 1)">
                                        Langganan <b>{item.namaToko}</b>{" "}
                                        mendekati jatuh tempo! Segera perbarui
                                        sebelum tanggal{" "}
                                        <b>
                                            {item.pembayaranBerikutnya === null
                                                ? ""
                                                : new Date(
                                                      item.pembayaranBerikutnya,
                                                  ).toLocaleString("id", {
                                                      day: "numeric",
                                                      month: "long",
                                                      year: "numeric",
                                                  })}
                                        </b>
                                        .
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="buttonred"
                                        disableElevation
                                        onClick={onOpenModalAlertPro}
                                        sx={{ minWidth: 130, maxWidth: 130 }}
                                    >
                                        Perpanjang Sekarang
                                    </Button>
                                </Stack>
                            )}
                        </Box>
                    ))}

            {ukmData.isTrial !== 1 && ukmData.isPro !== 1 && (
                <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        bgcolor: "rgba(69, 167, 121, 0.1)",
                        border: "1px solid rgba(69, 167, 121, 1)",
                    }}
                >
                    <Typography color="rgba(69, 167, 121, 1)">
                        Uji coba gratis selama 7 hari untuk mencoba
                        fitur-fitur ULO Standar
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        color="buttonulo"
                        disableElevation
                        onClick={onOpenModalTrial}
                        sx={{ minWidth: 100, maxWidth: 100 }}
                    >
                        Free Trial
                    </Button>
                </Stack>
            )}

            {ukmData.isTrial === 1 &&
                ukmData.isPro === 1 &&
                ukmData.trialTempo && (
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                        padding={1}
                        sx={{
                            bgcolor: "rgba(69, 167, 121, 0.1)",
                            border: "1px solid rgba(69, 167, 121, 1)",
                        }}
                    >
                        <Typography
                            component="div"
                            color="rgba(69, 167, 121, 1)"
                        >
                            Waktu trial anda akan habis dalam:{" "}
                            <CountdownDisplay expiredTime={expiredTime} />
                            <Typography
                                display="inline"
                                color="rgba(69, 167, 121, 1)"
                            >
                                {" "}
                                (sampai{" "}
                                {moment(ukmData.trialTempo).format("LL")})
                            </Typography>
                        </Typography>
                    </Stack>
                )}

            {ukmData.isTrial === 1 && ukmData.isPro !== 1 && (
                <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        bgcolor: "rgba(69, 167, 121, 0.1)",
                        border: "1px solid rgba(69, 167, 121, 1)",
                    }}
                >
                    <Typography color="rgba(69, 167, 121, 1)">
                        Waktu trial anda sudah habis! Segera upgrade untuk
                        mendapatkan fitur-fitur ULO Standar kembali!
                    </Typography>
                    <Button
                        variant="contained"
                        size="small"
                        color="buttonulo"
                        disableElevation
                        onClick={onOpenModalAlertPro}
                        sx={{ minWidth: 130, maxWidth: 130 }}
                    >
                        Upgrade ke ULO Standar
                    </Button>
                </Stack>
            )}
        </>
    );
}
